import { render } from "./NavBar.vue?vue&type=template&id=126fe24c&scoped=true&ts=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=126fe24c&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a2-CI\\_work\\63\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126fe24c"]])

export default __exports__